export const updateSessionStorageItemProperty = <T,>(
    key: string,
    propertyName: string,
    value: T
) => {
    const existingSessionStorageValue = sessionStorage.getItem(key);

    if (existingSessionStorageValue) {
        const updatedSessionStorageValue = {
            ...JSON.parse(existingSessionStorageValue),
            [propertyName]: value,
        };
        sessionStorage.setItem(key, JSON.stringify(updatedSessionStorageValue));
        return;
    }

    sessionStorage.setItem(key, JSON.stringify({ [propertyName]: value }));
};

export const getSessionStorageItemProperty = <T,>(
    key: string,
    propertyName: string
): T | undefined => {
    const existingSessionStorage = sessionStorage.getItem(key);

    if (!existingSessionStorage) {
        return;
    }

    const existingSessionStorageObject = JSON.parse(existingSessionStorage);

    return existingSessionStorageObject[propertyName];
};
